import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';
import PdfIcon from '../../images/PDF_24.png';
import WordIcon from '../../images/docx_16x1.png';
import ExcelIcon from '../../images/xlsx_16x1.png';
import  PowerPointIcon from '../../images/pptx_16x1.png';

const FileTypeIcon = ({ extension }) => {

    extension = extension.toLowerCase();
    switch (extension) {
        case ".jpg":
        case ".jpeg":
        case ".png":
        case ".bmp":
        case ".gif":
        case ".svg": {
            return (<span className="file-type-icon image"><Icon name="file-image" /></span>);
        }
        case ".pdf": {
            return (<img className="file-type-icon pdf" src={PdfIcon} />);
        }
        case ".doc":
        case ".docx": {
            return (<img className="file-type-icon word" src={WordIcon} />);
        }
        case ".xls":
        case ".xlsx": {
            return (<img className="file-type-icon excel" src={ExcelIcon} />);
        }
        case ".ppt":
        case ".pptx": {
            return (<img className="file-type-icon power-point" src={PowerPointIcon} />);
        }
        default: {
            return (<span className="file-type-icon default-file-type-icon"><Icon name="file" /></span>);
        }
    }
};

FileTypeIcon.propTypes = {
    extension: PropTypes.string.isRequired
};

export default FileTypeIcon;
